import type { ReactNode } from 'react';
import styles from './ui.module.css';

/**
 * Колонка карточек с общим промежутком.
 *
 * Отступы между строками теперь задаёт список, а не каждая карточка через
 * собственный <Group mode="plain">: на телефоне VKUI рисует группу без внешних полей, и
 * такой список слипался в сплошную ленту.
 */
export function CardList({ children }: { children: ReactNode }) {
  return <div className={styles.cardList}>{children}</div>;
}
